import { create } from 'apisauce';
import dayjs from 'dayjs';
import store from 'containers/store';
import * as actions from 'containers/App/actions';
import { getAuthToken } from 'utils/cookies';
import { api as apApi } from './index';

const token = getAuthToken();

const getDefaultLead = (orgId) => {
  return {
    'contact_first_name': '',
    'contact_last_name': '',
    'contact': {
      'phones': [
        {
          'field_value': '',
        },
      ],
      'emails': [
        {
          'field_value': '',
        },
      ],
      'addresses': [
        {
          '_isCreating': true,
          'city': '',
          'country': '',
        },
      ],
    },
    'status': 'new',
    'estimated_budget': null,
    'estimated_guest_count': null,
    'address': {
      'city': '',
      'region': '',
    },
    'timezone': null,
    'party': [
      [
        'bride',
        '',
        '',
      ],
      [
        'groom',
        '',
        '',
      ],
    ],
    'wedding_date': null,
    'date_inquiry': dayjs().format(),
    'organization_id': orgId,
    'notes': null,
  };
};

const newLead = (orgId) => {
  return new Promise((resolve, reject) => {
    const input = getDefaultLead(orgId);

    const api = create({
      baseURL: `${process.env.REACT_APP_AP_URL}`,
      headers: {
        'content-type': 'application/json, text/plain, */*',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${token}`,
      },
    });

    try {
      api.post(`/api/organization/${orgId}/leads`, input)
        .then(response => {
          // Redirect to login if auth denied.
          if (response.status === 401) {
            if (store) {
              store.dispatch(actions.pushAuthError(response.data?.signin_url ?? '/signin' ));
              return;
            }
          }

          resolve(response);
        })
        .catch(error => {
          return reject(error);
        });
    }
    catch(error) {
      reject(error);
    }
  });
};


const leadComment = (orgId, leadId) => {
  return new Promise((resolve, reject) => {
    const input = {
      'body': 'Created lead',
      'kind': 'aisleplanner',
    };
    const api = create({
      baseURL: `${process.env.REACT_APP_AP_URL}`,
      headers: {
        'content-type': 'application/json, text/plain, */*',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${token}`,
      },
    });

    try {
      api.post(`/api/organization/${orgId}/leads/${leadId}/comments`, input)
          .then(response => {
            // Redirect to login if auth denied.
            if (response.status === 401) {
              if (store) {
                store.dispatch(actions.pushAuthError(response.data?.signin_url ?? '/signin' ));
              }
            }

            resolve(response);
          })
          .catch(error => {
            return reject(error);
          });
    }
    catch(error) {
      reject(error);
    }

  });
};

const streamDownload = ({ orgId, params }) => {
  return new Promise((resolve, reject) => {
    const input = {
      client_offset: (new Date().getTimezoneOffset()),
      download_type: 'org.leads-csv',
      params,
    };
    const api = create({
      baseURL: `${process.env.REACT_APP_AP_URL}`,
      headers: {
        'content-type': 'application/json, text/plain, */*',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${token}`,
      },
    });

    try {
      api.post(`/api/organization/${orgId}/leads/downloads`, input)
        .then(response => {
          // Redirect to login if auth denied.
          if (response.status === 401) {
            if (store) {
              store.dispatch(actions.pushAuthError(response.data?.signin_url ?? '/signin' ));
              resolve(response);
            }
          }
          poll(response, api, input, orgId)
            .then(downloadResponse => {
              resolve(downloadResponse);
            })
            .catch(error => {
              return reject(error);
            });
        });
    }
    catch (error) {
      return Promise.reject(error);
    };
  });
};

const poll = (response, api, input, orgId) => {
  return new Promise((resolve, reject) => {
    if (response.data.status === 'ready') {
      resolve(response);
    }
    else if (response.data.status === 'error') {
      reject(new Error('Promise failed'));
    }
    else {
      setTimeout(() => {
        try {
          api.get(`/api/organization/${orgId}/leads/downloads/${response.data.token}`, input)
            .then((getResponse) => {
              resolve(poll(getResponse, api, input, orgId)
                .catch(error => {
                  return Promise.reject(error);
                }),
              );
            });
        }
        catch (error) {
          reject(error);
        }
      }, 3000);
    }
  });
};

const getLead = (orgId, leadId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.get();
};

const fetchLeadAssignments = (orgId, leadId) => {
  return apApi.get(`/api/organization/${orgId}/leads/${leadId}/lead-assignments`);
};

export { newLead };
export { leadComment };
export { streamDownload };
export { getLead };
export { fetchLeadAssignments };
